// extracted by mini-css-extract-plugin
export var black = "_19-6";
export var brand = "_19-1";
export var ddefault = "_19-0";
export var error = "_19-3";
export var gray = "_19-2";
export var highContrast = "_19-8";
export var outline = "_19-7";
export var success = "_19-5";
export var warning = "_19-4";